let countdownInterval = null;
let isLiveMatch = false;
let liveMatchInterval = null;
let callCount = 0;
let firstHalfTimer = null;
let secondHalfTimer = null;
var first_half_minutes;
var first_half_seconds;
var second_half_minutes;
var second_half_seconds;
let showRadio = false;

const latestMatchQuery = `?filter[soccerClubId]=${men_club_id}&isDetailed=0`;
const fetchLatestMatch = async () => {
  try {
    const response = await fetch(`${API_URL}match-center/soccer-matches/latest${latestMatchQuery}`, API_Header_Options);  
    //const response = await fetch(`${API_URL}match-center/soccer-matches/id/43?isDetailed=1`, API_Header_Options);  
    if (!response.ok) {
      throw new Error(`Fetch error: ${response.status}`);
    }
    const data = await response.json();
    $('.live-pre-game-banner-section .loader_wrap').remove();
    latest_men_match(data,callCount);    
    if(data.data.livetickerEvents == null || data.data.livetickerEvents.length == 0){
      loadInstageed();
    }
    callCount++;
  } catch (error) {
    console.error('Error fetching latest match:', error);
  }
};

fetchLatestMatch().then(() => {
  if (isLiveMatch) {
    liveMatchInterval = setInterval(fetchLatestMatch, 45000);
  }
});

function latest_men_match(response,callCount){
  let html = '';
  const { data } = response;
  
  if(data){
    
      $('.live-pre-game-banner-section').removeClass('hidden');
      
      let matchDate = data.date,
          arenaCity = '',          
          iSNP = false,
          isnV = false,
          scoreClass = '',
          score = '',
          live_score = '',
          score_split = '',
          teamHomeGoal = '',
          teamGuestGoal = '',
          teamHomeRed = '',
          teamGuestRed = '',
          teamHomeYellow = '',
          teamGuestYellow = '',
          teamHomeRedYellow = '',
          teamGuestRedYellow = '',
          timeHome,
          timeGuest,
          regularTimeHome = data.regularTimeHome,
          regularTimeGuest = data.regularTimeGuest,
          halfTimeHome = data.halfTimeHome,
          halfTimeGuest = data.halfTimeGuest,
          matchStatus = data.status,
          match_id = data.id;

       const { 
          date: matchDataDate,
          firstHalfStartTime, 
          firstHalfEndTime, 
          secondHalfStartTime, 
          secondHalfEndTime, 
          firstExtraHalfStartTime, 
          firstExtraHalfEndTime, 
          secondExtraHalfStartTime, 
          secondExtraHalfEndTime } = data
  
        const ogTimeData = {
          date: matchDataDate,
          firstHalfStartTime,
          firstHalfEndTime,
          secondHalfStartTime,
          secondHalfEndTime,
          firstExtraHalfStartTime,
          firstExtraHalfEndTime,
          secondExtraHalfStartTime,
          secondExtraHalfEndTime 
        }     

      let d1 = new Date(matchDate),
          now = new Date().toLocaleString('en-US', { timeZone: 'Europe/Zurich' }),
          d2 = new Date(now),
          match_day = d1.getUTCDate(),
          current_day = d2.getUTCDate();
      
      if((d1<d2) && (matchStatus != 'FINISHED')){
        isLiveMatch = true;  
      }else{
        isLiveMatch = false;
      }      
     
      if (data.arenaName!= null && data.arenaName != '') {
        arenaCity = data.arenaCity ? `, ${data.arenaCity}` : '';
      }

      if(data.arenaImage != null && data.arenaImage != ''){
        
          if($(".live-pre-game-banner-section .bg-img.arenaImage_loaded").length == 0){
            $(".live-pre-game-banner-section .bg-img").append(`
              <img src="${data.arenaImage}" alt="" class="arena_image arena_aico_image hidden">
            `);
            $(".live-pre-game-banner-section .bg-img").addClass('arenaImage_loaded');
          }
        

        $('.arena_aico_image').on("load", function () {         
          $('.arena_default_img').addClass('hidden');
          $(this).removeClass('hidden');
        });
      } 

     live_score = returnScore(data);
     if(live_score != 'VS'){
         score_split = live_score.split(":"); 
         timeHome = score_split[0];
         timeGuest = score_split[1];
      }
     
      var soccerLeague_name = '',
          soccerLeague_logo = '';
          
      if(data.soccerLeague){
        soccerLeague_name = data.soccerLeague.translations[0].slug || data.soccerLeague.translations[0].name || '';
        soccerLeague_logo = data.soccerLeague.lightLogo || '';
      }
      html +=`
      <div class="col-inner">
          <div class="section-title">
            <h1 class="title h1">${isLiveMatch?`JETZT LIVE`:`SPIELTAG`}</h1>
          </div>
          
          ${isLiveMatch?`<div class="match_status"></div>`:``}

          <div class="match-time-wrapper h2"></div>

          <div class="fixture h6">
            <div class="team_wrapper">
            ${data.homeClub != null?`
            
            ${data.homeClub.logo != null?`<img src="${data.homeClub.logo}" class="team-logo home" width="" height="" loading="lazy" >`:''}` :''}
            ${data.homeClub != null?`
            ${data.guestClub.logo != null?`<img src="${data.guestClub.logo}" class="team-logo away" width="" height="" loading="lazy" >`:''}
            `:''}
            </div>
            <div class="score_wrapper ${live_score == 'VS'?'hidden':''}">
            <strong class="score h2"
              ><span class="homeScore">${timeHome}</span>
              <span class="guestScore">${timeGuest}</span>
            </strong>
            </div>
          </div>
          <div class="info-wrap-main">
            <div class="info-wrapper h6">
              <strong class="match-date"><span class="match_day_date">${format_date(matchDate, "WWWW, DD.MM.YYYY")}</span><br/><span class="match_kickoff_time">${format_date(matchDate, "HH.mm Uhr")}</span></strong>
              <span class="match-location">${data.arenaName?`${data.arenaName}`:''}${arenaCity}</span>
            </div>
            ${soccerLeague_logo != ''?`
            <div class="logo-rsl">                
              <img src="${soccerLeague_logo}" alt="${soccerLeague_name}" loading="lazy" width="90" height="auto">
            </div>
            `:''}
          </div>
          <div class="button-wrapper">
            <a href="/pages/match-center/${match_id}" class="btn border h6">
              Matchcenter
            </a>
            ${(data.ticketsUrl != null && data.ticketsUrl != "") && (d1>d2)?`
              <a href="${!/^https?:\/\//.test(data.ticketsUrl)?`//${data.ticketsUrl}`:data.ticketsUrl}" class="btn border h6 ticket_btn" >Tickets</a>
            `:""}
            ${isLiveMatch?`
              <a href="/pages/fcsg-fm" class="btn border h6 ticket_btn" >LIVE-RADIO</a>
            `:''}
          </div>
        </div>
      `;

      $('.live-pre-game-banner-section .left-col').html(html);
      match_status(data.status);
      if((callCount > 0) || (data.livetickerEvents != null && data.livetickerEvents.length > 0)){
        getMatchInstastories();
      }      

      let liveTickerHtml = '';
      let live_ticker_content = data.livetickerEvents || [];
      

      publish('liveMatchTickerData',live_ticker_content);     

      // Countdown for before Match
      function updateCountdown() {
        const now = new Date().toLocaleString('en-US', { timeZone: 'Europe/Zurich' });
        const currentTime = new Date(now);
        const timeLeft = Math.floor((d1 - currentTime) / 1000); // Time left in seconds

        if (timeLeft > 0) {
          const days = Math.floor(timeLeft / 86400);
          const hours = String(Math.floor((timeLeft % 86400) / 3600)).padStart(2, "0");
          const minutes = String(Math.floor((timeLeft % 3600) / 60)).padStart(2, "0");
          const seconds = String(timeLeft % 60).padStart(2, "0");

          const match_timer = `
            <div class="countdown-wrapper">              
              <div class="digit">
                  <span>Stunden</span>
                  <strong class="hours h2">${hours}</strong>
              </div>
              <div class="digit">
                  <span>Minuten</span>
                  <strong class="minute h2">${minutes}</strong>
              </div>
              <div class="digit">
                  <span>Sekunden</span>
                  <strong class="seconds h2">${seconds}</strong>
              </div>
            </div>
          `;

          $('.live-pre-game-banner-section .countdown-wrapper').remove();
          $('.live-pre-game-banner-section .fixture').before(match_timer);
        }else if(timeLeft == 0){
          fetchLatestMatch().then(() => {
            liveMatchInterval = setInterval(fetchLatestMatch, 45000); // 45000
          });
        } else {
          // Countdown finished
          $('.live-pre-game-banner-section .countdown-wrapper').remove();
          clearInterval(countdownInterval); // Stop countdown timer          
        }
      }

      // Check if match is live
      //console.log('isLiveMatch',isLiveMatch);
      if(!isLiveMatch){
        clearInterval(liveMatchInterval);
        $('.live-pre-game-banner-section .match-time-wrapper').remove();
      } else {
        live_match_timer(data,"section");
      }
      if (!countdownInterval) {
        countdownInterval = setInterval(updateCountdown, 1000); // Update countdown every second
      }

      //match_kickoff_time      
      if(match_day < current_day && matchStatus == 'FINISHED'){        
        $('.live-pre-game-banner-section .info-wrap-main .match_kickoff_time').remove();
      }

      if(callCount < 2){
        publish('HomepageNewsLoaded',true);
      }      
    
  }
}

// load first time when page loads and liveticker is empty
function loadInstageed(){
 fetch(API_URL + "social-media-posts?sort=-publishedAt&filter[source]=INSTAGRAM_STORIES&filter[areLatestPosts]=1&filter[externalUserId]="+men_insta_id, API_Header_Options)
  .then((response) => response.json())
  .then((result) => {
    let data = result.data,html = '';

    if (data != null && data.length > 0) {
      for (let a = 0; a < data.length; a++) {
        // attributes = data[a].attributes[0];
        let liveTicker = data[a].attributes[0],
              source = liveTicker.source || '';
        if(source == "INSTAGRAM_STORIES"){
          let imageUrl = liveTicker.imageUrl || '';
          let videoUrl = liveTicker.videoUrl || '';
          let title = liveTicker.title || liveTicker.description || '';
          let ctaText = liveTicker.ctaText || '';
          let ctaUrl = liveTicker.ctaUrl || '';
          html += `
             <div class="liveTickerItem collage__item collage__item--instagram_stories span-1${videoUrl != ''?` has_mp4_video`:''}" data-id="${liveTicker.id}" data-span="1">
               <div class="collage-card card-wrapper product-card-wrapper color-scheme-2 gradient">`;

                html += `
                <div class="media media--transparent ratio" style="--ratio-percent: 150%">
                  ${
                    imageUrl
                    ? `<img src="${imageUrl}" alt="${title}" width="328" height="auto">`
                    : ''
                  }
                  ${
                    videoUrl
                    ? `
                      <div class="video_wrap">
                        <video width="100%" height="100%" playsinline src="${videoUrl}#t=0.1" poster="${liveTicker.webThumbnailUrl || imageUrl || defaultVideoPoster}">
                          <source src="${videoUrl}#t=0.1" type="video/mp4">
                        </video>
                        <span class="icon-play deferred-media__poster-button motion-reduce">
                          <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">
                            <defs>
                              <clipPath id="clip-path">
                                <rect width="100" height="100" fill="currentColor"></rect>
                              </clipPath>
                            </defs>
                            <g clip-path="url(#clip-path)">
                              <path d="M49.666,0A49.984,49.984,0,1,0,99.332,49.983,49.882,49.882,0,0,0,49.666,0m0,94.308A44.326,44.326,0,1,1,93.709,49.983,44.235,44.235,0,0,1,49.666,94.308" fill="currentColor"></path>
                              <path d="M80.923,48.875,34.069,25.3a2.8,2.8,0,0,0-2.735.125A2.83,2.83,0,0,0,30,27.828V74.983a2.833,2.833,0,0,0,1.333,2.407,2.8,2.8,0,0,0,2.735.124L80.923,53.937a2.839,2.839,0,0,0,0-5.062m-45.3,21.531v-38l37.757,19Z" fill="currentColor"></path>
                            </g>
                          </svg>
                        </span>
                      </div>
                    `
                    : ''
                  }
                  
                  ${
                    title
                    ? `<div class="insta-heading"><div class="collage-card-title h4">${title}</div></div>`
                    : ''
                  }
                  ${ctaText != '' && ctaUrl != ''?`
                  <!-- <div class="button_wrap">
                    <a href="${!/^https?:\/\//.test(ctaUrl)?`//${ctaUrl}`:ctaUrl}" class="btn btn-green story_cta_btn">${ctaText}</a>
                  </div> -->
                  `:''}
                </div>`;
          
          html += `</div></div>`;
        }
      }
      if ($('.live-pre-game-slider').hasClass('slick-initialized')) {
          $('.live-pre-game-slider').slick('unslick'); // Destroy the slider if initialized
      }
      $('.live-pre-game-slider-wrap .aico-skeleton-horizontal').remove();
      $('.live-pre-game-slider').html(html);
      
      initFeedSlider();
      
      
      setTimeout(() => {
        $(".live-pre-game-slider-wrap .live-pre-game-slider").slick('destroy');
        $(".live-pre-game-slider-wrap .live-pre-game-slider").slick('refresh');
      }, 200); // Small delay before initialization

      const playButtons = document.querySelectorAll('.live-pre-game-slider .has_mp4_video .icon-play');

      playButtons.forEach(button => {
        button.addEventListener('click', function() {

          const parentItem = button.closest('.has_mp4_video');

          // Pause all videos first
          const allVideos = document.querySelectorAll('.live-pre-game-slider .has_mp4_video video');

          allVideos.forEach(video => {
            video.pause();
            video.currentTime = 1; // Optional: reset the video to the beginning
            $(playButtons).show();
            $('.has_mp4_video').removeClass('video_playing');
          });


          if (parentItem) {
            // Find the video inside this parent
            const video = parentItem.querySelector('video');
            if (video) {
              video.play();
              $(button).hide(); // Hide the play button
              if ($(window).width() >= 540) {
                $(".insta-heading", parentItem).addClass("hidden");
              }
              setTimeout(function(){
                $(parentItem).addClass('video_playing');
              },200);
              // Show play button when video ends
              video.addEventListener('ended', function() {
                video.currentTime = 1;
                $(button).show(); // Show the play button again after the video ends
                $(parentItem).removeClass('video_playing');
                $(".insta-heading", parentItem).removeClass("hidden");
              });
              video.addEventListener("pause", function() {
                // console.log("The video is paused!");
                $(".insta-heading", parentItem).removeClass("hidden");
              });
            } else {
              console.error('Video not found within the parent element');
            }
          }
        });
      });
    }
  });
}

// loads everytime when matchstarted.
function getMatchInstastories(){
  let liveTickerData = [];
  subscribe("liveMatchTickerData", function(response_data){
    let html = '';
    if(response_data.length > 0){
      for(let a=0;a<response_data.length;a++){
        liveTickerData.push(response_data[a]);
        let liveTicker = response_data[a];
        let socialMediaPost = liveTicker.socialMediaPost || '';
        if(socialMediaPost != ''){
          let source = socialMediaPost.source;
          let type_LowerCase = source.toLowerCase();
          let has_mp4_video = '';
          let imageUrl = socialMediaPost.imageUrl || '';
          let videoUrl = socialMediaPost.videoUrl || '';
          let title = socialMediaPost.title || socialMediaPost.description || '';
          let ctaText = ''; // socialMediaPost.ctaText || '';
          let ctaUrl = ''; //socialMediaPost.ctaUrl || '';
          
          if (source != "YOUTUBE" && videoUrl) {
            has_mp4_video = ' has_mp4_video';
          }
          if (videoUrl && !videoUrl.startsWith("https://")) {
            if (source != "YOUTUBE") {
               videoUrl = Aico_storage_url + videoUrl;
            }
          }
          
          html += `
             <div class="liveTickerItem collage__item collage__item--${type_LowerCase} span-1${has_mp4_video}" data-id="${socialMediaPost.id}" data-span="1">
               <div class="collage-card card-wrapper product-card-wrapper color-scheme-2 gradient">`;
    
                html += `
                <div class="media media--transparent ratio" style="--ratio-percent: 150%">
                  ${
                    imageUrl
                    ? `<img src="${imageUrl}" alt="${title}" loading="eager" width="328" height="auto">`
                    : ''
                  }
                  ${
                    videoUrl
                    ? `
                      <div class="video_wrap">
                        ${source != "YOUTUBE"?`<video width="100%" playsinline height="100%" preload="metadata" poster="${imageUrl || defaultVideoPoster}"><source src="${videoUrl}#t=0.1" type="video/mp4"></video>`:''}
                     <span class="icon-play deferred-media__poster-button motion-reduce">
                       ${source == "YOUTUBE"?`<a href="${videoPageURL}/${socialMediaPost.id}"> <!--<i class="icon-youtube"></i>--><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100" height="100" viewBox="0 0 100 100">
                        <defs>
                          <clipPath id="clip-path">
                            <rect id="Rectangle_1087" data-name="Rectangle 1087" width="100" height="100" transform="translate(-0.364 -0.103)" fill="#fff"></rect>
                          </clipPath>
                        </defs>
                        <g id="Group_1040" data-name="Group 1040" transform="translate(3 27.084)">
                          <g id="Group_910" data-name="Group 910" transform="translate(-2.636 -26.981)" clip-path="url(#clip-path)">
                            <path id="Path_643" data-name="Path 643" d="M49.666,0A49.984,49.984,0,1,0,99.332,49.983,49.882,49.882,0,0,0,49.666,0m0,94.308A44.326,44.326,0,1,1,93.709,49.983,44.235,44.235,0,0,1,49.666,94.308" transform="translate(-0.03 0.026)" fill="#fff"></path>
                            <path id="Path_644" data-name="Path 644" d="M80.923,48.875,34.069,25.3a2.8,2.8,0,0,0-2.735.125A2.83,2.83,0,0,0,30,27.828V74.983a2.833,2.833,0,0,0,1.333,2.407,2.8,2.8,0,0,0,2.735.124L80.923,53.937a2.839,2.839,0,0,0,0-5.062m-45.3,21.531v-38l37.757,19Z" transform="translate(-1.917 -1.397)" fill="#fff"></path>
                          </g>
                        </g>
                        </svg></a>`: ` <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100" height="100" viewBox="0 0 100 100">
                        <defs>
                          <clipPath id="clip-path">
                            <rect id="Rectangle_1087" data-name="Rectangle 1087" width="100" height="100" transform="translate(-0.364 -0.103)" fill="#fff"></rect>
                          </clipPath>
                        </defs>
                        <g id="Group_1040" data-name="Group 1040" transform="translate(3 27.084)">
                          <g id="Group_910" data-name="Group 910" transform="translate(-2.636 -26.981)" clip-path="url(#clip-path)">
                            <path id="Path_643" data-name="Path 643" d="M49.666,0A49.984,49.984,0,1,0,99.332,49.983,49.882,49.882,0,0,0,49.666,0m0,94.308A44.326,44.326,0,1,1,93.709,49.983,44.235,44.235,0,0,1,49.666,94.308" transform="translate(-0.03 0.026)" fill="#fff"></path>
                            <path id="Path_644" data-name="Path 644" d="M80.923,48.875,34.069,25.3a2.8,2.8,0,0,0-2.735.125A2.83,2.83,0,0,0,30,27.828V74.983a2.833,2.833,0,0,0,1.333,2.407,2.8,2.8,0,0,0,2.735.124L80.923,53.937a2.839,2.839,0,0,0,0-5.062m-45.3,21.531v-38l37.757,19Z" transform="translate(-1.917 -1.397)" fill="#fff"></path>
                          </g>
                        </g>
                        </svg>`}
                        </span>
                      </div>
                    `
                    : ''
                  }
                  
                  ${
                    title
                    ? `<div class="insta-heading"><div class="collage-card-title h4">${title}</div></div>`
                    : ''
                  }
                  ${ctaText != '' && ctaUrl != ''?`
                  <div class="button_wrap">
                    <a href="${!/^https?:\/\//.test(ctaUrl)?`//${ctaUrl}`:ctaUrl}" class="btn btn-green story_cta_btn">${ctaText}</a>
                  </div>
                  `:''}
                </div>`;
          
          html += `</div></div>`;
        }
        else
        {
          let id = liveTicker.id,
                type = liveTicker.type,
                title = liveTicker.title,
                content = liveTicker.content,
                minute = liveTicker.minute,
                matchId = liveTicker.matchId,
                sortOrder = liveTicker.sortOrder,
                buttonLabel = liveTicker.buttonLabel,
                buttonUrl = liveTicker.buttonUrl;
             
              //let lower_type = type.toLowerCase();
              //let lower_title = title.toLowerCase();

              let type_class = '';
              let type_icon = '';
              if(type == 'Default'){               
                 
                type_class = 'type-default';
                type_icon = `<svg xmlns="http://www.w3.org/2000/svg" width="35.968" height="35.967" viewBox="0 0 35.968 35.967">
                  <g id="Ball" transform="translate(0.522 0.522)">
                    <path id="Path_21" data-name="Path 21" d="M135.643,150.019a17.458,17.458,0,1,1,14.379-20.07A17.459,17.459,0,0,1,135.643,150.019Z" transform="translate(-115.335 -115.333)" fill="none" stroke="currentColor" stroke-width="1"/>
                    <path id="Path_22" data-name="Path 22" d="M153.664,175.22l5.816,3.357v6.714l-5.816,3.359-5.814-3.359v-6.714Z" transform="translate(-142.015 -164.473)" fill="none" stroke="currentColor" stroke-width="1"/>
                    <path id="Path_23" data-name="Path 23" d="M218.416,175.22l5.814,3.357v6.714l-5.814,3.359-5.816-3.359v-6.714Z" transform="translate(-195.144 -164.473)" fill="none" stroke="currentColor" stroke-width="1"/>
                    <path id="Path_24" data-name="Path 24" d="M282.093,190.852l-4.743-2.739V181.4l4.743-2.739" transform="translate(-248.269 -167.295)" fill="none" stroke="currentColor" stroke-width="1"/>
                    <path id="Path_25" data-name="Path 25" d="M121.442,178.67l4.742,2.737v6.714l-4.744,2.739" transform="translate(-120.344 -167.303)" fill="none" stroke="currentColor" stroke-width="1"/>
                    <g id="Group_12" data-name="Group 12" transform="translate(11.352 1.102)">
                      <path id="Path_26" data-name="Path 26" d="M234.381,131.124l-2.321-7,2.613-2.651" transform="translate(-222.456 -121.47)" fill="none" stroke="currentColor" stroke-width="1"/>
                      <path id="Path_27" data-name="Path 27" d="M178.883,131.124l2.319-7-2.612-2.651" transform="translate(-178.59 -121.47)" fill="none" stroke="currentColor" stroke-width="1"/>
                      <line id="Line_2" data-name="Line 2" x1="6.992" transform="translate(2.612 2.651)" fill="none" stroke="currentColor" stroke-width="1"/>
                    </g>
                    <g id="Group_13" data-name="Group 13" transform="translate(11.352 24.168)">
                      <path id="Path_28" data-name="Path 28" d="M234.381,249.99l-2.321,7,2.613,2.651" transform="translate(-222.456 -249.99)" fill="none" stroke="currentColor" stroke-width="1"/>
                      <path id="Path_29" data-name="Path 29" d="M178.883,249.99l2.319,7-2.612,2.651" transform="translate(-178.59 -249.99)" fill="none" stroke="currentColor" stroke-width="1"/>
                      <line id="Line_3" data-name="Line 3" x2="6.992" transform="translate(2.612 7.001)" fill="none" stroke="currentColor" stroke-width="1"/>
                    </g>
                  </g>
                </svg>
                `;
              }
              else if(type == 'Goal'){
                 type_class = 'goal fcsg';
                 type_icon = `<svg xmlns="http://www.w3.org/2000/svg" width="46.411" height="38.329" viewBox="0 0 46.411 38.329">
                  <path id="FCSG-Icons-RGB-Tor" d="M62.21,32H18.2A1.179,1.179,0,0,0,17,33.2V57.206a1.179,1.179,0,0,0,1.2,1.2h4a.507.507,0,0,0,.24-.04c.04,0,.08-.04.12-.04s.08-.04.12-.04.08-.04.12-.08a.14.14,0,0,0,.08-.04.7.7,0,0,0,.2-.16l3.641-3.641h3.4c-.2.44-.4.88-.56,1.32h0a11.218,11.218,0,0,0-.52,3.441,11.517,11.517,0,0,0,.56,3.481,11.2,11.2,0,0,0,4.081,5.6h0a11.212,11.212,0,0,0,13.123,0h0a11.2,11.2,0,0,0,4.081-5.6,10.971,10.971,0,0,0,0-6.922h0a7.7,7.7,0,0,0-.56-1.32h3.4l3.641,3.641a1.22,1.22,0,0,0,.84.36h4a1.179,1.179,0,0,0,1.2-1.2V33.2A1.179,1.179,0,0,0,62.21,32ZM25,52.725l-1.6,1.6V38.4H25Zm20.365-.64a8.637,8.637,0,0,1,2.721,3.281l-3.161.96L41.406,53.6V50.484A8.408,8.408,0,0,1,45.367,52.085Zm-7.242,9.922-1.08-3.881,3.121-2.4,3.121,2.4-1.08,3.881Zm.88-8.4-3.521,2.721-3.161-.96a9.356,9.356,0,0,1,2.721-3.281,8.577,8.577,0,0,1,3.961-1.6Zm-7.162,8.322a9,9,0,0,1-.44-2.721,6.891,6.891,0,0,1,.16-1.56l3.161.96,1.2,4.361-1.8,2.561A8.786,8.786,0,0,1,31.843,61.927Zm4.2,5.041,1.8-2.561h4.721l1.8,2.561a8.842,8.842,0,0,1-8.322,0Zm12.523-5.041a8.786,8.786,0,0,1-2.281,3.6l-1.8-2.561,1.2-4.361,3.161-.96a10.318,10.318,0,0,1,.16,1.56A9,9,0,0,1,48.567,61.927Zm-1.76-11.763a11.166,11.166,0,0,0-13.2,0,12.411,12.411,0,0,0-2,1.84H27.4V38.4H53.008V52H48.767A10.7,10.7,0,0,0,46.807,50.164ZM57.009,38.4V54.325l-1.6-1.6V38.4Zm4,17.6h-1.6V37.2a1.179,1.179,0,0,0-1.2-1.2H22.2A1.179,1.179,0,0,0,21,37.2v18.8H19.4V34.4H61.01Z" transform="translate(-17 -32)" fill="currentColor"/>
                </svg>`;
              }
              else if(type == 'Goal Opponent'){
                 type_class = 'goal opponent';
                 type_icon = `<svg xmlns="http://www.w3.org/2000/svg" width="46.411" height="38.329" viewBox="0 0 46.411 38.329">
                        <path id="FCSG-Icons-RGB-Tor" d="M62.21,32H18.2A1.179,1.179,0,0,0,17,33.2V57.206a1.179,1.179,0,0,0,1.2,1.2h4a.507.507,0,0,0,.24-.04c.04,0,.08-.04.12-.04s.08-.04.12-.04.08-.04.12-.08a.14.14,0,0,0,.08-.04.7.7,0,0,0,.2-.16l3.641-3.641h3.4c-.2.44-.4.88-.56,1.32h0a11.218,11.218,0,0,0-.52,3.441,11.517,11.517,0,0,0,.56,3.481,11.2,11.2,0,0,0,4.081,5.6h0a11.212,11.212,0,0,0,13.123,0h0a11.2,11.2,0,0,0,4.081-5.6,10.971,10.971,0,0,0,0-6.922h0a7.7,7.7,0,0,0-.56-1.32h3.4l3.641,3.641a1.22,1.22,0,0,0,.84.36h4a1.179,1.179,0,0,0,1.2-1.2V33.2A1.179,1.179,0,0,0,62.21,32ZM25,52.725l-1.6,1.6V38.4H25Zm20.365-.64a8.637,8.637,0,0,1,2.721,3.281l-3.161.96L41.406,53.6V50.484A8.408,8.408,0,0,1,45.367,52.085Zm-7.242,9.922-1.08-3.881,3.121-2.4,3.121,2.4-1.08,3.881Zm.88-8.4-3.521,2.721-3.161-.96a9.356,9.356,0,0,1,2.721-3.281,8.577,8.577,0,0,1,3.961-1.6Zm-7.162,8.322a9,9,0,0,1-.44-2.721,6.891,6.891,0,0,1,.16-1.56l3.161.96,1.2,4.361-1.8,2.561A8.786,8.786,0,0,1,31.843,61.927Zm4.2,5.041,1.8-2.561h4.721l1.8,2.561a8.842,8.842,0,0,1-8.322,0Zm12.523-5.041a8.786,8.786,0,0,1-2.281,3.6l-1.8-2.561,1.2-4.361,3.161-.96a10.318,10.318,0,0,1,.16,1.56A9,9,0,0,1,48.567,61.927Zm-1.76-11.763a11.166,11.166,0,0,0-13.2,0,12.411,12.411,0,0,0-2,1.84H27.4V38.4H53.008V52H48.767A10.7,10.7,0,0,0,46.807,50.164ZM57.009,38.4V54.325l-1.6-1.6V38.4Zm4,17.6h-1.6V37.2a1.179,1.179,0,0,0-1.2-1.2H22.2A1.179,1.179,0,0,0,21,37.2v18.8H19.4V34.4H61.01Z" transform="translate(-17 -32)" fill="currentColor"/>
                      </svg>`;
              }
              else if(type == 'Goal Disallowed'){
                 type_class = 'goal_disallowed';
                 type_icon = `<svg xmlns="http://www.w3.org/2000/svg" width="41.945" height="38.33" viewBox="0 0 41.945 38.33">
                  <path id="FCSG-Icons-RGB-Kein-Tor" d="M57.86,29.23H47.649l3.869-5.525a1.085,1.085,0,0,0-1.779-1.244L45,29.23H30.943l-4.737-6.769a1.085,1.085,0,1,0-1.779,1.244L28.3,29.23H18.085A1.083,1.083,0,0,0,17,30.315v21.7A1.083,1.083,0,0,0,18.085,53.1H21.7a1.068,1.068,0,0,0,.213-.022.934.934,0,0,0,.094-.029c.036-.011.072-.018.108-.033a.954.954,0,0,0,.1-.054.863.863,0,0,0,.08-.043,1.019,1.019,0,0,0,.166-.137l3.3-3.3h5.062l-6.4,9.141a1.085,1.085,0,0,0,1.779,1.244L33.474,49.48h9l7.268,10.385a1.083,1.083,0,0,0,.89.463,1.108,1.108,0,0,0,.622-.2,1.085,1.085,0,0,0,.268-1.511l-6.4-9.141H50.18l3.3,3.3a1.076,1.076,0,0,0,.767.318c.014,0,.029,0,.043,0H57.86a1.083,1.083,0,0,0,1.085-1.085V30.315A1.083,1.083,0,0,0,57.86,29.23ZM43.483,31.4l-1.012,1.446h-9L32.462,31.4Zm-2.531,3.616-2.98,4.256-2.98-4.256ZM19.17,31.4H29.815l1.012,1.446H21.7a1.083,1.083,0,0,0-1.085,1.085v17H19.17Zm5.062,16.547-1.446,1.446V35.016h1.446Zm2.17-.636V35.016h5.945l4.3,6.147-4.3,6.147Zm8.592,0,2.98-4.256,2.98,4.256Zm4.3-6.147,4.3-6.147h5.945V47.31H43.6ZM53.16,35.016V49.393l-1.446-1.446V35.016Zm3.616,15.907H55.329V33.931a1.083,1.083,0,0,0-1.085-1.085H45.118L46.13,31.4H56.776Z" transform="translate(-17 -21.998)"/>
                </svg>`;
              }
              else if(type == 'Yellow Card'){
                type_class = 'card yellow-card'; 
                type_icon = `<svg version="1.1" id="Gelbe_Karten:_Karte" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                            	 x="0px" y="0px" viewBox="0 0 150 150" style="enable-background:new 0 0 150 150;" xml:space="preserve">
                            <path d="M100,22H50c-4.41,0-8,3.59-8,8v90c0,4.41,3.59,8,8,8h50c4.41,0,8-3.59,8-8V30C108,25.59,104.41,22,100,22z M102,120
                            	c0,1.1-0.9,2-2,2H50c-1.1,0-2-0.9-2-2V30c0-1.1,0.9-2,2-2h50c1.1,0,2,0.9,2,2V120z"/>
                            </svg>`;
              }
              else if(type == 'Red Card'){
                 type_class = 'card red-card'; 
                  type_icon = `<svg version="1.1" id="Rote_Karten:_Karte" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                                 y="0px" viewBox="0 0 150 150" style="enable-background:new 0 0 150 150;" xml:space="preserve">
                              <path d="M100,22H50c-4.4,0-8,3.6-8,8v90c0,4.4,3.6,8,8,8h50c4.4,0,8-3.6,8-8V30C108,25.6,104.4,22,100,22z M48,58.8v-6.5l54,54v6.5
                                L48,58.8z M81.2,122L48,88.8v-6.5L87.8,122H81.2z M66.2,122L48,103.8v-6.5L72.8,122H66.2z M48,43.8v-6.5l54,54v6.5L48,43.8z
                                 M68.8,28L102,61.2v6.5L62.2,28H68.8z M77.2,28h6.5L102,46.2v6.5L77.2,28z M102,30v7.8L92.2,28h7.8C101.1,28,102,28.9,102,30z
                                 M50,28h3.8L102,76.2v6.5L48.3,29C48.6,28.4,49.3,28,50,28z M48,120v-7.8l9.8,9.8H50C48.9,122,48,121.1,48,120z M100,122h-3.8
                                L48,73.8v-6.5l53.7,53.7C101.4,121.6,100.7,122,100,122z" fill="#ffffff"/>
                              </svg>`;
              } 
              else if(type == 'Yellow-Red Card'){
                 type_class = 'card yellow-red-card'; 
                type_icon = `<svg version="1.1" id="Gelb-Rote_Karten:_Karten" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                              	 x="0px" y="0px" viewBox="0 0 150 150" style="enable-background:new 0 0 150 150;" xml:space="preserve">
                              <path d="M115,22H70c-4.41,0-8,3.59-8,8v2H35c-4.41,0-8,3.59-8,8v80c0,4.41,3.59,8,8,8h45c4.41,0,8-3.59,8-8v-2h27c4.41,0,8-3.59,8-8
                              	V30C123,25.59,119.41,22,115,22z M106.24,112L88,93.76v-6.52L112.76,112H106.24z M91.24,112L88,108.76v-6.52l9.76,9.76H91.24z
                              	 M88,78.76v-6.52l29,29v6.52L88,78.76z M88,63.76v-6.52l29,29v6.52L88,63.76z M88,48.76v-6.52l29,29v6.52L88,48.76z M82.24,28h6.52
                              	L117,56.24v6.52L82.24,28z M97.24,28h6.52L117,41.24v6.52L97.24,28z M117,30v2.76L112.24,28H115C116.1,28,117,28.9,117,30z M70,28
                              	h3.76l4,4h-6.52l-2.98-2.98C68.61,28.42,69.25,28,70,28z M82,120c0,1.1-0.9,2-2,2H35c-1.1,0-2-0.9-2-2V40c0-1.1,0.9-2,2-2h34.83
                              	c0.06,0,0.13,0.02,0.19,0.02S70.14,38,70.21,38H80c1.1,0,2,0.9,2,2V120z" fill="#ffffff"/>
                              </svg>`;
              }  
              else if(type == 'Quote'){
                 type_class = 'type-quote';
                 type_icon = '<i class="icon-zitat"></i>';
              }
              else if(type == 'Substitution'){
                  type_class = 'type-substitution';
                  type_icon = `<svg xmlns="http://www.w3.org/2000/svg" width="47.168" height="38.22" viewBox="0 0 47.168 38.22">
                  <g id="FCSG-Icons-RGB-Wechsel" transform="translate(-9.6 -22)">
                    <path id="Path_1434" data-name="Path 1434" d="M59.043,42.965l-5.4-4.5c-.036,0-.036-.036-.072-.036l-.036-.036a.275.275,0,0,0-.18-.072h-.036a.217.217,0,0,0-.144-.036H48.453a1.061,1.061,0,0,0-1.081,1.081,1.614,1.614,0,0,1-1.621,1.621,1.677,1.677,0,0,1-1.621-1.693,1.061,1.061,0,0,0-1.081-1.081H41.428V32.05l2.053,1.009a1.109,1.109,0,0,0,.468.108,1.532,1.532,0,0,0,.4-.072,1.029,1.029,0,0,0,.612-.612l1.8-4.5a1.062,1.062,0,0,0-.324-1.225l-5.4-4.5c-.036,0-.036-.036-.072-.036l-.036-.036a.275.275,0,0,0-.18-.072h-.036a.217.217,0,0,0-.144-.036H35.845a1.061,1.061,0,0,0-1.081,1.081,1.614,1.614,0,0,1-1.621,1.621,1.677,1.677,0,0,1-1.621-1.693A1.061,1.061,0,0,0,30.441,22H25.65c-.036,0-.108.036-.144.036H25.47c-.072.036-.108.036-.144.072l-.036.036c-.036,0-.036.036-.072.036l-5.4,4.5a1.119,1.119,0,0,0-.324,1.225l1.8,4.5a1.029,1.029,0,0,0,.612.612,1.3,1.3,0,0,0,.4.072,1,1,0,0,0,.468-.108l2.053-1.009V42.893A1.061,1.061,0,0,0,25.9,43.974h6.16a.512.512,0,0,0,.072.216l1.8,4.5a1.029,1.029,0,0,0,.612.612,1.3,1.3,0,0,0,.4.072,1,1,0,0,0,.468-.108l2.053-1.009V59.1a1.061,1.061,0,0,0,1.081,1.081H52.955A1.061,1.061,0,0,0,54.036,59.1V48.26l2.053,1.009a1.109,1.109,0,0,0,.468.108,1.532,1.532,0,0,0,.4-.072,1.029,1.029,0,0,0,.612-.612l1.8-4.5A1.062,1.062,0,0,0,59.043,42.965ZM43.373,30.609l-1.945-.973V25.386l3.026,2.522Zm-20.461,0-1.081-2.666,3.026-2.522v4.215Zm4.107-.324V24.161H29.5a3.8,3.8,0,0,0,7.277,0h2.486V38.21H38.4a.132.132,0,0,0-.108.036c-.036,0-.072.036-.108.036s-.072.036-.108.036a.126.126,0,0,0-.072.036c-.036.036-.072.036-.108.072a.035.035,0,0,0-.036.036l-4.035,3.35H27.019Zm8.5,16.534L34.44,44.154l3.026-2.522v4.215Zm16.354,11.2H39.627V40.372h2.486a3.8,3.8,0,0,0,7.277,0h2.486V58.023Zm4.107-11.2-1.945-.973V41.6l3.026,2.522Z" transform="translate(-6.288)"/>
                    <path id="Path_1435" data-name="Path 1435" d="M112.346,32.23a1.044,1.044,0,0,0-1.513,0L109.068,34V32.086A10.116,10.116,0,0,0,98.981,22h-.9a1.081,1.081,0,0,0,0,2.161h.9a7.948,7.948,0,0,1,7.925,7.925V34l-1.765-1.765a1.07,1.07,0,1,0-1.513,1.513l3.6,3.6.036.036.108.108.036.036a.275.275,0,0,0,.18.072h0a.325.325,0,0,0,.18.036h.036a.325.325,0,0,1,.18.036h.036a.457.457,0,0,0,.216-.036h.036c.072,0,.108-.036.18-.036.036,0,.036-.036.072-.036.036-.036.072-.036.144-.072a.633.633,0,0,0,.18-.144l3.6-3.6A1.157,1.157,0,0,0,112.346,32.23Z" transform="translate(-55.916)"/>
                    <path id="Path_1436" data-name="Path 1436" d="M24.153,98.072h-.9a7.948,7.948,0,0,1-7.925-7.925V88.238L17.093,90a1.045,1.045,0,0,0,1.513,0,1.044,1.044,0,0,0,0-1.513l-3.6-3.6-.036-.036-.108-.108-.036-.036a.275.275,0,0,0-.18-.072h-.036a.217.217,0,0,0-.144-.036h-.216a1.066,1.066,0,0,0-.36.072.035.035,0,0,0-.036.036c-.036.036-.072.036-.144.072l-.036.036c-.036.036-.108.072-.144.108l-3.6,3.6a1.07,1.07,0,0,0,1.513,1.513L13.2,88.274v1.909A10.116,10.116,0,0,0,23.289,100.27h.865a1.061,1.061,0,0,0,1.081-1.081A1.092,1.092,0,0,0,24.153,98.072Z" transform="translate(0 -40.05)"/>
                  </g>
                </svg>`;
              }
              else if(type == 'VAR'){
                  type_class = 'type-var';
                  type_icon = `<svg xmlns="http://www.w3.org/2000/svg" width="65.245" height="38.284" viewBox="0 0 65.245 38.284">
                  <g id="FCSG-Icons-RGB-VAR" transform="translate(-14.5 -39.5)">
                    <path id="Path_1437" data-name="Path 1437" d="M31.9,76.533a.3.3,0,0,0,.324.216h4.853a.364.364,0,0,0,.324-.216l4.475-11.539a6.725,6.725,0,0,0,.377-2.966V52.97a.255.255,0,0,0-.27-.27H38.152a.255.255,0,0,0-.27.27v9.868L34.647,71.95l-3.181-9.113V52.97a.255.255,0,0,0-.27-.27H27.368a.255.255,0,0,0-.27.27v9.059a6.725,6.725,0,0,0,.377,2.966Z" transform="translate(-5.804 -6.082)"/>
                    <path id="Path_1438" data-name="Path 1438" d="M60.024,76.749H63.8a.255.255,0,0,0,.27-.27V70.6h6.578v5.877a.255.255,0,0,0,.27.27H74.69a.255.255,0,0,0,.27-.27V67.528a8.158,8.158,0,0,0-.377-2.858L70.97,52.916a.3.3,0,0,0-.324-.216H64.014a.364.364,0,0,0-.324.216L60.077,64.671a8.158,8.158,0,0,0-.377,2.858v8.951A.342.342,0,0,0,60.024,76.749ZM66.872,56.69h.863L70.592,66.5H64.014Z" transform="translate(-20.827 -6.082)"/>
                    <path id="Path_1439" data-name="Path 1439" d="M94.77,76.749H98.6a.255.255,0,0,0,.27-.27V68.553h3.882l2.48,8.034a.3.3,0,0,0,.324.216H109.6c.216,0,.324-.162.216-.324l-2.8-8.358c1.294-.593,1.833-1.833,1.833-3.613V56.8c0-2.642-1.294-4.1-4.26-4.1H94.77a.255.255,0,0,0-.27.27v23.51A.255.255,0,0,0,94.77,76.749Zm4.1-19.951h5.554a.053.053,0,0,1,.054.054V64.4a.053.053,0,0,1-.054.054H98.868Z" transform="translate(-36.863 -6.082)"/>
                    <path id="Path_1440" data-name="Path 1440" d="M78.127,39.5H16.118A1.589,1.589,0,0,0,14.5,41.118V76.167a1.589,1.589,0,0,0,1.618,1.618h62.01a1.589,1.589,0,0,0,1.618-1.618V41.118A1.589,1.589,0,0,0,78.127,39.5ZM76.51,74.549H17.735V42.735H76.51Z"/>
                  </g>
                </svg>
                `;
              }
              else if(type == 'Action'){
                  type_class = 'type-action';
                  type_icon = `<svg xmlns="http://www.w3.org/2000/svg" width="9.365" height="38.176" viewBox="0 0 9.365 38.176">
                  <g id="FCSG-Icons-RGB-Aktion" transform="translate(-61.998 -22)">
                    <path id="Path_1441" data-name="Path 1441" d="M70.283,102h-7.2A1.079,1.079,0,0,0,62,103.08v7.2a1.079,1.079,0,0,0,1.08,1.08h7.2a1.079,1.079,0,0,0,1.08-1.08v-7.2A1.079,1.079,0,0,0,70.283,102Zm-1.08,7.2H64.161v-5.042H69.2Z" transform="translate(-0.001 -51.188)"/>
                    <path id="Path_1442" data-name="Path 1442" d="M63.98,49.371h5.4a1.081,1.081,0,0,0,1.08-1.041l.9-25.21A1.083,1.083,0,0,0,70.282,22h-7.2A1.083,1.083,0,0,0,62,23.12l.9,25.21A1.081,1.081,0,0,0,63.98,49.371Zm5.183-25.21L68.337,47.21H65.02L64.2,24.161Z"/>
                  </g>
                </svg>`;
              }
              else if(type == 'Half Time Whistle' || type == 'Half Time Whistle/Referee' || type == 'Kick-Off/Full Time Whistle'){                 
                 type_class = 'type-half_time';
                 type_icon = `<svg xmlns="http://www.w3.org/2000/svg" width="53.998" height="38.379" viewBox="0 0 53.998 38.379">
                  <g id="FCSG-Icons-RGB-Schiedsrichter" transform="translate(-14.5 -27)">
                    <path id="Path_1425" data-name="Path 1425" d="M50.033,64.5a8.033,8.033,0,1,0,8.033,8.033A8.056,8.056,0,0,0,50.033,64.5Zm0,13.388a5.355,5.355,0,1,1,5.355-5.355A5.371,5.371,0,0,1,50.033,77.888Z" transform="translate(-15.228 -20.765)" fill="currentColor"/>
                    <path id="Path_1426" data-name="Path 1426" d="M67.159,52H34.805a13.644,13.644,0,0,0-13.031,9.684,4.749,4.749,0,0,0-2.588-.759,4.686,4.686,0,1,0,0,9.372,4.749,4.749,0,0,0,2.588-.759,13.613,13.613,0,0,0,26.6-2.767L67.382,63.6A1.348,1.348,0,0,0,68.5,62.264V53.339A1.315,1.315,0,0,0,67.159,52ZM46.185,54.678h6.248v1.785H46.185Zm-27,12.942a2.008,2.008,0,1,1,2.008-2.008A2,2,0,0,1,19.186,67.619ZM65.82,61.148,46.854,64.272a1.348,1.348,0,0,0-1.116,1.339A10.933,10.933,0,1,1,34.805,54.678h8.7V57.8a1.315,1.315,0,0,0,1.339,1.339h8.925A1.315,1.315,0,0,0,55.11,57.8V54.678H65.82Z" transform="translate(0 -13.843)" fill="currentColor"/>
                    <path id="Path_1427" data-name="Path 1427" d="M90.839,36.372a1.315,1.315,0,0,0,1.339-1.339V28.339a1.339,1.339,0,1,0-2.678,0v6.694A1.315,1.315,0,0,0,90.839,36.372Z" transform="translate(-41.53)" fill="currentColor"/>
                    <path id="Path_1428" data-name="Path 1428" d="M100.283,39.01a1.374,1.374,0,0,0,.58.134,1.315,1.315,0,0,0,1.2-.759l2.231-4.463a1.327,1.327,0,0,0-2.365-1.2L99.7,37.18A1.346,1.346,0,0,0,100.283,39.01Z" transform="translate(-47.092 -2.772)" fill="currentColor"/>
                    <path id="Path_1429" data-name="Path 1429" d="M76.834,38.406a1.315,1.315,0,0,0,1.2.759,1.235,1.235,0,0,0,.58-.134,1.285,1.285,0,0,0,.58-1.785l-2.231-4.463a1.327,1.327,0,0,0-2.365,1.2Z" transform="translate(-33.193 -2.793)" fill="currentColor"/>
                  </g>
                </svg>`;
              }
              else if(type == 'Full Time Whistle'){                 
                 type_class = 'start type-full_time';
                 type_icon = `<svg xmlns="http://www.w3.org/2000/svg" width="53.998" height="38.379" viewBox="0 0 53.998 38.379">
                  <g id="FCSG-Icons-RGB-Schiedsrichter" transform="translate(-14.5 -27)">
                    <path id="Path_1425" data-name="Path 1425" d="M50.033,64.5a8.033,8.033,0,1,0,8.033,8.033A8.056,8.056,0,0,0,50.033,64.5Zm0,13.388a5.355,5.355,0,1,1,5.355-5.355A5.371,5.371,0,0,1,50.033,77.888Z" transform="translate(-15.228 -20.765)" fill="currentColor"/>
                    <path id="Path_1426" data-name="Path 1426" d="M67.159,52H34.805a13.644,13.644,0,0,0-13.031,9.684,4.749,4.749,0,0,0-2.588-.759,4.686,4.686,0,1,0,0,9.372,4.749,4.749,0,0,0,2.588-.759,13.613,13.613,0,0,0,26.6-2.767L67.382,63.6A1.348,1.348,0,0,0,68.5,62.264V53.339A1.315,1.315,0,0,0,67.159,52ZM46.185,54.678h6.248v1.785H46.185Zm-27,12.942a2.008,2.008,0,1,1,2.008-2.008A2,2,0,0,1,19.186,67.619ZM65.82,61.148,46.854,64.272a1.348,1.348,0,0,0-1.116,1.339A10.933,10.933,0,1,1,34.805,54.678h8.7V57.8a1.315,1.315,0,0,0,1.339,1.339h8.925A1.315,1.315,0,0,0,55.11,57.8V54.678H65.82Z" transform="translate(0 -13.843)" fill="currentColor"/>
                    <path id="Path_1427" data-name="Path 1427" d="M90.839,36.372a1.315,1.315,0,0,0,1.339-1.339V28.339a1.339,1.339,0,1,0-2.678,0v6.694A1.315,1.315,0,0,0,90.839,36.372Z" transform="translate(-41.53)" fill="currentColor"/>
                    <path id="Path_1428" data-name="Path 1428" d="M100.283,39.01a1.374,1.374,0,0,0,.58.134,1.315,1.315,0,0,0,1.2-.759l2.231-4.463a1.327,1.327,0,0,0-2.365-1.2L99.7,37.18A1.346,1.346,0,0,0,100.283,39.01Z" transform="translate(-47.092 -2.772)" fill="currentColor"/>
                    <path id="Path_1429" data-name="Path 1429" d="M76.834,38.406a1.315,1.315,0,0,0,1.2.759,1.235,1.235,0,0,0,.58-.134,1.285,1.285,0,0,0,.58-1.785l-2.231-4.463a1.327,1.327,0,0,0-2.365,1.2Z" transform="translate(-33.193 -2.793)" fill="currentColor"/>
                  </g>
                </svg>`;
              }  
              else if(type == 'Lineup'){     
                 type_class = 'type-lineup';
                 type_icon = `<svg xmlns="http://www.w3.org/2000/svg" width="49.176" height="38.33" viewBox="0 0 49.176 38.33">
                  <path id="FCSG-Icons-RGB-Aufstellung" d="M55.759,25.848l-4.52-3.616-.047-.033-.047-.033A1.344,1.344,0,0,0,51,22.091a.176.176,0,0,0-.025-.011.83.83,0,0,0-.177-.054l-.051-.011A.825.825,0,0,0,50.589,22c-.007,0-.018,0-.025,0H46.948a1.083,1.083,0,0,0-1.085,1.085,1.627,1.627,0,1,1-3.254,0A1.083,1.083,0,0,0,41.524,22H37.909c-.011,0-.022,0-.033,0a1.079,1.079,0,0,0-.152.014l-.058.011a.966.966,0,0,0-.174.054c-.011,0-.022.011-.033.014-.047.022-.09.047-.137.072l-.051.033a.367.367,0,0,0-.047.033l-4.52,3.616a1.081,1.081,0,0,0-.387,1.059l.9,4.52a1.079,1.079,0,0,0,.586.763,1.113,1.113,0,0,0,.477.112,1.086,1.086,0,0,0,.485-.116l2.046-1.023v2.585H34.966a1.083,1.083,0,0,0-1.085,1.085,2.308,2.308,0,0,1-4.614,0,1.083,1.083,0,0,0-1.085-1.085H26.339V31.163l2.046,1.023a1.086,1.086,0,0,0,.485.116,1.063,1.063,0,0,0,.477-.112,1.079,1.079,0,0,0,.586-.763l.9-4.52a1.081,1.081,0,0,0-.387-1.059l-4.52-3.616-.047-.033-.047-.033a1.06,1.06,0,0,0-.141-.076.091.091,0,0,1-.025-.014.83.83,0,0,0-.177-.054l-.051-.011a1.244,1.244,0,0,0-.163-.018c-.007,0-.018,0-.025,0H21.638a1.083,1.083,0,0,0-1.085,1.085,1.627,1.627,0,0,1-3.254,0,1.083,1.083,0,0,0-1.085-1.085H12.6c-.011,0-.022,0-.033,0a1.079,1.079,0,0,0-.152.014l-.058.011a.966.966,0,0,0-.174.054c-.011,0-.022.011-.033.014-.047.022-.09.047-.134.072l-.051.033-.047.033L7.4,25.841A1.081,1.081,0,0,0,7.013,26.9l.9,4.52a1.079,1.079,0,0,0,.586.763,1.113,1.113,0,0,0,.477.112,1.086,1.086,0,0,0,.485-.116l2.046-1.023v9.1A1.083,1.083,0,0,0,12.6,41.338H15.43l1.562,4.682a1.075,1.075,0,0,0,.571.64,1.059,1.059,0,0,0,.456.1,1.084,1.084,0,0,0,.4-.076l3.037-1.215V59.235a1.083,1.083,0,0,0,1.085,1.085H40.621a1.083,1.083,0,0,0,1.085-1.085V45.47l3.034,1.211a1.113,1.113,0,0,0,.4.076,1.059,1.059,0,0,0,.456-.1,1.085,1.085,0,0,0,.571-.64l1.562-4.682h2.835a1.083,1.083,0,0,0,1.085-1.085v-9.09l2.046,1.023a1.086,1.086,0,0,0,.485.116,1.063,1.063,0,0,0,.477-.112,1.079,1.079,0,0,0,.586-.763l.9-4.52A1.078,1.078,0,0,0,55.759,25.848Zm-20.682,3.76-.5-2.48,2.242-1.793v3.4Zm-6.993,0-1.746-.871v-3.4l2.242,1.793Zm-18.317,0-.5-2.48,2.242-1.793v3.4Zm3.916-.2V24.163h1.605a3.8,3.8,0,0,0,7.275,0h1.605v9.582H22.546a1.233,1.233,0,0,0-.2.018l-.054.011a.781.781,0,0,0-.148.047.151.151,0,0,0-.036.014.891.891,0,0,0-.163.09.276.276,0,0,0-.04.029.539.539,0,0,0-.072.054l-6.02,5.16h-2.13Zm5,14.835L17.473,40.6l3.984-3.413v5.948Zm20.848,13.91H23.627V35.914h3.616a4.493,4.493,0,0,0,8.678,0h3.616V58.151Zm4.939-13.91-2.77-1.106V37.187L45.69,40.6Zm5-5.073h-2.13L41.326,34a.833.833,0,0,0-.069-.051l-.043-.033a1.16,1.16,0,0,0-.163-.087.2.2,0,0,0-.043-.014,1,1,0,0,0-.137-.043l-.058-.011a1.062,1.062,0,0,0-.184-.018H38.993V24.163H40.6a3.8,3.8,0,0,0,7.275,0h1.605V39.168Zm3.916-9.56-1.746-.871v-3.4l2.242,1.793Z" transform="translate(-6.991 -21.99)"/>
                </svg>`;
              }
              else if(type == 'Stadium'){    
                 type_class = 'type-stadium';
                 type_icon = `<svg xmlns="http://www.w3.org/2000/svg" width="42.324" height="38.33" viewBox="0 0 42.324 38.33">
                  <path id="FCSG-Icons-RGB-Stadion" d="M64.283,50.437c0-.08.04-.12.04-.2v-.08h0a.506.506,0,0,0-.04-.24v-.04a.305.305,0,0,0-.08-.2v-.04L60.21,41.653a1.2,1.2,0,0,0-1.078-.679H56.337V37.381h6.788a1.151,1.151,0,0,0,1.038-.639,1.243,1.243,0,0,0-.04-1.238l-1.557-2.316,1.557-2.316a1.224,1.224,0,0,0-1-1.877H55.139a1.176,1.176,0,0,0-1.2,1.2v10.78H44.359v-5.59h6.788a1.151,1.151,0,0,0,1.038-.639,1.243,1.243,0,0,0-.04-1.238l-1.557-2.316,1.557-2.316a1.224,1.224,0,0,0-1-1.877H43.161a1.176,1.176,0,0,0-1.2,1.2V40.974H32.381V37.381h6.788a1.151,1.151,0,0,0,1.038-.639,1.243,1.243,0,0,0-.04-1.238L38.61,33.189l1.557-2.316a1.154,1.154,0,0,0,.04-1.238A1.2,1.2,0,0,0,39.169,29H31.183a1.176,1.176,0,0,0-1.2,1.2v10.78H27.191a1.177,1.177,0,0,0-1.078.679L22.12,49.639v.04c-.04.08-.04.16-.08.24v.04c0,.08-.04.16-.04.24h0v.08a.36.36,0,0,0,.04.2c0,.04,0,.04.04.08.04.08.04.12.08.16v.04l7.985,13.974a1.191,1.191,0,0,0,1.038.6H55.139a1.191,1.191,0,0,0,1.038-.6l7.985-13.974v-.04c.04-.04.04-.12.08-.16A.147.147,0,0,0,64.283,50.437ZM56.337,31.392h4.552L60.13,32.51a1.14,1.14,0,0,0,0,1.318l.759,1.118H56.337Zm-11.978-2h4.552l-.759,1.118a1.14,1.14,0,0,0,0,1.318l.759,1.118H44.359Zm-11.978,2h4.552l-.759,1.118a1.14,1.14,0,0,0,0,1.318l.759,1.118H32.381ZM61.168,48.96H58.054l-1.4-5.59h1.717ZM48.751,62.934l3.314-11.579h3.274L50.348,62.934Zm-4.392,0V51.356H49.55L46.236,62.934Zm-4.272,0L36.773,51.356h5.191V62.934Zm-4.112,0L30.984,51.356h3.274l3.314,11.579ZM32.1,43.37h3.514l-1.4,5.59H30.7Zm9.862,0v5.59h-5.27l1.4-5.59Zm6.269,0,1.4,5.59h-5.27V43.37Zm3.833,5.59-1.4-5.59h3.514l1.4,5.59ZM27.949,43.37h1.717l-1.4,5.59H25.154Zm-2.675,7.985h3.114l4.951,11.579H31.862ZM54.461,62.934H52.983l4.951-11.579h3.154Z" transform="translate(-22 -27)"/>
                </svg>`;
              }
              else if(type == 'Tickets'){   
                type_class = 'type-tickets';
                type_icon = `<svg xmlns="http://www.w3.org/2000/svg" width="39.191" height="38.273" viewBox="0 0 39.191 38.273">
                 <g id="FCSG-Icons-RGB-Tickets" transform="translate(-19.5 -19.6)">
                   <path id="Path_1443" data-name="Path 1443" d="M87.8,51.318A1.049,1.049,0,0,0,86.318,52.8l2.472,2.472a1.024,1.024,0,0,0,1.483,0,1.024,1.024,0,0,0,0-1.483Z" transform="translate(-43.02 -20.313)" fill="#fff"/>
                   <path id="Path_1444" data-name="Path 1444" d="M58.374,32.24,56.538,30.4a1.024,1.024,0,0,0-1.483,0,1.535,1.535,0,0,1-2.189,0,1.6,1.6,0,0,1,0-2.224,1.024,1.024,0,0,0,0-1.483L51.63,25.461a1.024,1.024,0,0,0-1.483,0,1.535,1.535,0,0,1-2.189,0,1.6,1.6,0,0,1,0-2.224,1.024,1.024,0,0,0,0-1.483l-1.836-1.836a1.024,1.024,0,0,0-1.483,0l-6.285,6.144h0L26.314,38.1H20.559A1.04,1.04,0,0,0,19.5,39.16v2.648a1.04,1.04,0,0,0,1.059,1.059,1.589,1.589,0,1,1,0,3.178A1.04,1.04,0,0,0,19.5,47.1V48.87a1.04,1.04,0,0,0,1.059,1.059,1.589,1.589,0,1,1,0,3.178A1.04,1.04,0,0,0,19.5,54.166v2.648a1.04,1.04,0,0,0,1.059,1.059H55.867a1.04,1.04,0,0,0,1.059-1.059V54.166a1.04,1.04,0,0,0-1.059-1.059,1.589,1.589,0,0,1,0-3.178,1.04,1.04,0,0,0,1.059-1.059V47.1a1.04,1.04,0,0,0-1.059-1.059,1.589,1.589,0,0,1,0-3.178,1.04,1.04,0,0,0,1.059-1.059V39.16A1.04,1.04,0,0,0,55.867,38.1H54l4.378-4.378A1.024,1.024,0,0,0,58.374,32.24Zm-3.566,8.65a3.716,3.716,0,0,0-.071,7.1,3.716,3.716,0,0,0,.071,7.1v.671H48.1V53.283a1.059,1.059,0,1,0-2.118,0v2.472H21.618v-.671a3.716,3.716,0,0,0,.071-7.1,3.716,3.716,0,0,0-.071-7.1V40.22H45.981v2.507a1.059,1.059,0,0,0,2.118,0V40.22h6.708Zm-3.354-3.213-1.73-1.73A1.049,1.049,0,0,0,48.24,37.43l.671.671H29.28L39.1,28.286l1.73,1.73a1.024,1.024,0,0,0,1.483,0,1.024,1.024,0,0,0,0-1.483l-1.73-1.73,4.7-4.7.459.459a3.7,3.7,0,0,0,4.943,5.014,3.673,3.673,0,0,0,5.014,4.908l.459.459Z" fill="#fff"/>
                   <path id="Path_1445" data-name="Path 1445" d="M95.559,92A1.04,1.04,0,0,0,94.5,93.059V96.59a1.059,1.059,0,1,0,2.118,0V93.059A1.04,1.04,0,0,0,95.559,92Z" transform="translate(-48.519 -46.837)" fill="#fff"/>
                 </g>
               </svg>`;
             } else if (type == "Corner Kick") {
               type_class = 'type-eckball';
               type_icon = `<svg version="1.1" id="Eckbälle:_Eckfahne" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                   x="0px" y="0px" viewBox="0 0 150 150" style="enable-background:new 0 0 150 150;" xml:space="preserve">
                 <path d="M125.86,122.13L78,107.77V63h37c1.66,0,3-1.34,3-3V30c0-1.66-1.34-3-3-3H78v-2c0-1.66-1.34-3-3-3c-1.66,0-3,1.34-3,3v82.77
                   l-23.56,7.07c-0.12,0.03-0.23,0.06-0.35,0.1l-23.96,7.19c-1.59,0.48-2.49,2.15-2.01,3.74c0.39,1.3,1.58,2.14,2.87,2.14
                   c0.29,0,0.58-0.04,0.86-0.13l22.84-6.85C56.69,125.59,65.75,128,75,128c9.26,0,18.31-2.41,26.29-6.98l22.84,6.85
                   c0.29,0.09,0.58,0.13,0.86,0.13c1.29,0,2.48-0.84,2.87-2.14C128.35,124.28,127.45,122.6,125.86,122.13z M112,33v24H78V33H112z
                   M75,122c-6.15,0-12.19-1.22-17.82-3.52L75,113.13l17.82,5.35C87.2,120.78,81.15,122,75,122z"/>
                 </svg>`;
             } else if (type == "Free Kick") {
               type_class = 'type-freistoss';
               type_icon = `<svg version="1.1" id="Freistösse:_Taktik" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                   x="0px" y="0px" viewBox="0 0 150 150" style="enable-background:new 0 0 150 150;" xml:space="preserve">
                 <g>
                   <path d="M121.74,62.5l5.38-5.38c1.17-1.17,1.17-3.07,0-4.24c-1.17-1.17-3.07-1.17-4.24,0l-5.38,5.38l-5.38-5.38
                     c-1.17-1.17-3.07-1.17-4.24,0l-5.38,5.38l-5.38-5.38c-1.17-1.17-3.07-1.17-4.24,0l-5.38,5.38l-5.38-5.38
                     c-1.17-1.17-3.07-1.17-4.24,0l-5.38,5.38l-5.38-5.38c-1.17-1.17-3.07-1.17-4.24,0l-5.38,5.38l-5.38-5.38
                     c-1.17-1.17-3.07-1.17-4.24,0c-1.17,1.17-1.17,3.07,0,4.24l5.38,5.38l-5.38,5.38c-1.17,1.17-1.17,3.07,0,4.24
                     C48.46,72.71,49.23,73,50,73s1.54-0.29,2.12-0.88l5.38-5.38l5.38,5.38C63.46,72.71,64.23,73,65,73s1.54-0.29,2.12-0.88l5.38-5.38
                     l5.38,5.38C78.46,72.71,79.23,73,80,73s1.54-0.29,2.12-0.88l5.38-5.38l5.38,5.38C93.46,72.71,94.23,73,95,73s1.54-0.29,2.12-0.88
                     l5.38-5.38l5.38,5.38c0.59,0.59,1.35,0.88,2.12,0.88s1.54-0.29,2.12-0.88l5.38-5.38l5.38,5.38c0.59,0.59,1.35,0.88,2.12,0.88
                     s1.54-0.29,2.12-0.88c1.17-1.17,1.17-3.07,0-4.24L121.74,62.5z M65,65.76l-3.26-3.26L65,59.24l3.26,3.26L65,65.76z M80,65.76
                     l-3.26-3.26L80,59.24l3.26,3.26L80,65.76z M95,65.76l-3.26-3.26L95,59.24l3.26,3.26L95,65.76z M110,65.76l-3.26-3.26l3.26-3.26
                     l3.26,3.26L110,65.76z"/>
                   <path d="M97.01,101.22C97.01,101.21,97.01,101.21,97.01,101.22c-0.01-0.02-0.01-0.04-0.02-0.05c-1.32-4.08-3.97-7.71-7.45-10.25
                     C86.03,88.36,81.86,87,77.5,87c-4.36,0-8.53,1.36-12.05,3.92c-3.48,2.53-6.12,6.17-7.45,10.25c0,0.01-0.01,0.03-0.01,0.04
                     c0,0,0,0.01,0,0.01c0,0.01,0,0.01,0,0.02c-0.65,2.03-0.98,4.13-0.98,6.26c0,2.15,0.34,4.29,1,6.33c1.32,4.08,3.97,7.71,7.45,10.25
                     c0.01,0.01,0.02,0.01,0.02,0.02c0,0,0,0,0.01,0.01c0.01,0,0.01,0.01,0.02,0.01c3.51,2.54,7.66,3.89,12,3.89
                     c4.34,0,8.49-1.35,12-3.89c0.01,0,0.01-0.01,0.02-0.01c0,0,0,0,0.01-0.01c0.01-0.01,0.02-0.01,0.02-0.02
                     c3.48-2.53,6.12-6.17,7.45-10.25c0.67-2.05,1-4.18,1-6.33c0-2.13-0.33-4.24-0.98-6.27C97.01,101.23,97.01,101.22,97.01,101.22z
                     M90.02,100.21l-4.05,1.23l-5.47-4.18v-3.95c1.98,0.42,3.85,1.24,5.52,2.45C87.65,96.95,89.01,98.48,90.02,100.21z M74.58,111.5
                     l-1.52-5.58l4.45-3.4l4.45,3.4l-1.53,5.58H74.58z M68.98,95.77c1.67-1.21,3.54-2.03,5.52-2.45v3.95l-5.47,4.18l-4.05-1.23
                     C65.99,98.48,67.35,96.95,68.98,95.77z M63,107.5c0-0.53,0.04-1.06,0.1-1.59l4.07,1.24l1.85,6.77l-2.3,3.25
                     c-1.35-1.5-2.39-3.28-3.01-5.19C63.24,110.53,63,109.02,63,107.5z M71.56,120.72l2.28-3.22h7.32l2.28,3.22
                     c-1.85,0.84-3.87,1.28-5.94,1.28C75.42,122,73.41,121.56,71.56,120.72z M91.29,111.98c-0.62,1.91-1.66,3.68-3.01,5.19l-2.3-3.25
                     l1.85-6.77l4.07-1.24c0.06,0.53,0.1,1.06,0.1,1.59C92,109.02,91.76,110.53,91.29,111.98z"/>
                   <path d="M45.67,101.62C34.27,91.81,28,78.8,28,65c0-12.23,4.94-23.83,13.99-33.14v8.15c0,1.66,1.34,3,3,3s3-1.34,3-3V25.23
                     c0-0.03,0-0.07,0-0.1V25c0-0.01,0-0.02,0-0.04c0-0.18-0.02-0.36-0.05-0.53c-0.01-0.03-0.01-0.05-0.02-0.08
                     c-0.04-0.16-0.08-0.32-0.15-0.48c-0.01-0.03-0.03-0.06-0.04-0.1c-0.06-0.14-0.13-0.27-0.22-0.41c-0.03-0.04-0.05-0.08-0.08-0.12
                     c-0.05-0.07-0.09-0.15-0.15-0.21c-0.04-0.04-0.08-0.08-0.12-0.12c-0.04-0.04-0.08-0.08-0.12-0.11c-0.1-0.1-0.21-0.19-0.32-0.26
                     c-0.05-0.03-0.1-0.06-0.15-0.09c-0.11-0.07-0.23-0.14-0.35-0.19c-0.06-0.03-0.13-0.05-0.2-0.08c-0.11-0.04-0.22-0.08-0.34-0.11
                     c-0.08-0.02-0.16-0.03-0.25-0.04c-0.11-0.02-0.22-0.03-0.33-0.03c-0.04,0-0.07-0.01-0.11-0.01H30c-1.66,0-3,1.34-3,3s1.34,3,3,3
                     h7.36C27.41,38.38,22,51.32,22,65c0,15.58,7.02,30.2,19.75,41.16l1.29,1.11c0.57,0.49,1.26,0.73,1.96,0.73
                     c0.84,0,1.68-0.35,2.27-1.04c1.08-1.26,0.94-3.15-0.31-4.23L45.67,101.62z"/>
                 </g>
                 </svg>`;
             } else if (type == "Stoppage Time") {
               type_class = 'type-nachspielzeit';
               type_icon = `
                 <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                 width="727.000000pt" height="749.000000pt" viewBox="0 0 727.000000 749.000000"
                 preserveAspectRatio="xMidYMid meet">
                <g transform="translate(0.000000,749.000000) scale(0.100000,-0.100000)"
                fill="#000000" stroke="none">
                <path d="M2906 7402 c-68 -37 -89 -69 -94 -142 -6 -77 1 -102 40 -146 54 -61
                69 -64 343 -64 l245 0 0 -135 0 -135 -49 0 c-69 0 -274 -27 -416 -55 -297 -59
                -548 -145 -830 -285 -646 -320 -1163 -823 -1498 -1460 -176 -335 -292 -692
                -346 -1067 -102 -700 16 -1409 338 -2028 307 -593 776 -1075 1365 -1405 357
                -200 721 -321 1176 -391 127 -20 184 -23 450 -23 266 0 323 3 450 23 455 70
                819 191 1176 391 504 282 915 670 1221 1153 428 676 598 1480 482 2280 -54
                375 -170 732 -346 1067 -360 683 -933 1217 -1651 1535 -197 87 -497 178 -722
                219 -124 22 -313 46 -371 46 l-49 0 0 135 0 135 245 0 c274 0 289 3 343 64 39
                44 46 69 40 146 -5 73 -26 105 -94 142 l-49 28 -675 0 -675 0 -49 -28z m1109
                -1016 c645 -87 1233 -374 1703 -831 483 -468 803 -1121 877 -1788 19 -170 19
                -514 0 -684 -110 -989 -733 -1878 -1628 -2323 -262 -131 -470 -203 -739 -259
                -218 -45 -339 -56 -598 -56 -259 0 -380 11 -598 56 -269 56 -477 128 -739 259
                -895 445 -1518 1334 -1628 2323 -19 170 -19 514 0 684 86 767 488 1497 1095
                1983 440 352 999 586 1525 639 61 6 124 13 140 15 64 9 486 -4 590 -18z"/>
                <path d="M3445 6149 c-780 -53 -1516 -449 -1983 -1067 -293 -389 -468 -806
                -539 -1287 -27 -184 -24 -582 5 -773 107 -685 466 -1306 1007 -1737 187 -149
                503 -329 725 -413 551 -209 1161 -234 1730 -70 398 114 815 355 1129 651 93
                88 233 251 319 370 262 365 426 763 494 1199 29 191 32 589 5 773 -97 654
                -413 1246 -892 1668 -189 166 -358 280 -585 397 -344 175 -667 263 -1065 290
                -165 11 -177 11 -350 -1z m565 -406 c374 -60 772 -236 1062 -470 l69 -56 -169
                -171 c-182 -184 -199 -210 -189 -293 9 -83 100 -163 185 -163 70 0 118 33 285
                199 l158 156 35 -40 c66 -76 214 -308 274 -429 119 -242 184 -453 225 -728 8
                -54 15 -105 15 -113 0 -13 -32 -15 -232 -15 -205 0 -238 -3 -273 -19 -46 -21
                -79 -54 -94 -94 -15 -39 -14 -121 3 -160 16 -39 76 -94 114 -104 15 -5 132 -8
                261 -8 l233 1 -6 -76 c-37 -409 -209 -822 -496 -1192 l-45 -57 -161 159 c-205
                203 -256 228 -361 180 -48 -21 -98 -90 -109 -148 -14 -74 6 -105 189 -290
                l172 -173 -34 -27 c-299 -239 -597 -384 -971 -473 -78 -19 -263 -48 -302 -49
                -15 0 -17 24 -20 243 -3 266 -6 278 -68 331 -92 77 -231 52 -290 -54 -24 -44
                -25 -50 -28 -287 l-4 -242 -46 5 c-452 54 -870 224 -1205 491 l-69 55 170 172
                c182 184 199 210 189 293 -12 111 -147 192 -254 153 -15 -6 -105 -88 -199
                -181 l-171 -170 -56 70 c-211 260 -381 622 -452 963 -16 76 -45 257 -45 283 0
                13 32 15 233 15 252 0 283 6 334 61 64 70 56 208 -15 272 -44 40 -87 46 -331
                47 l-233 0 7 78 c8 90 46 285 76 386 82 285 259 619 437 826 l30 35 164 -161
                c90 -89 177 -169 195 -178 37 -18 108 -21 150 -5 63 24 122 109 123 177 0 59
                -40 114 -202 278 l-159 161 63 50 c321 253 704 419 1103 478 61 8 120 18 132
                20 l21 5 4 -243 c3 -266 6 -278 68 -331 92 -77 231 -52 290 54 24 44 25 50 28
                288 l4 243 46 -6 c26 -4 90 -13 142 -22z"/>
                <path d="M2587 4549 c-70 -37 -109 -127 -93 -216 7 -33 49 -79 338 -369 l330
                -332 -16 -64 c-44 -174 0 -352 118 -476 92 -97 173 -140 307 -161 109 -18 251
                15 345 80 229 157 293 458 146 685 -120 185 -337 269 -564 218 l-71 -16 -326
                324 c-179 179 -339 330 -354 336 -42 18 -117 14 -160 -9z m1102 -1013 c86 -45
                86 -177 0 -222 -67 -34 -151 -1 -178 70 -39 104 78 203 178 152z"/>
                </g>
                </svg>`;
             } else if (type == "Celebration") {
               type_class = 'type-parade';
               type_icon = `<svg version="1.1" id="Torwart_hält:_Handschuh" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                     x="0px" y="0px" viewBox="0 0 150 150" style="enable-background:new 0 0 150 150;" xml:space="preserve">
                   <path d="M121.1,65.5l-1.1-2.1c-1-2-2.7-3.4-4.8-4.1c-2.1-0.7-4.3-0.4-6.3,0.6l-12.3,6.8l7.7-38.7c0.9-4.3-2-8.5-6.3-9.4L95.4,18
                     c-4.3-0.9-8.5,1.9-9.4,6.2l-1.8,9.3L83.3,17c-0.2-4.2-3.8-7.5-8-7.5h-3.1c-4.2,0-7.7,3.3-8,7.5l-0.8,15.3l-2-10.6
                     c-0.9-4.3-5.1-7.1-9.4-6.3l-2.8,0.6c-4.3,0.9-7,4.9-6.3,9.2l3.4,20.5L42,37.2c-1.7-3.4-5.4-5.1-9.1-4.2l-0.7,0.2
                     c-2.2,0.5-4.1,2-5.1,4c-1.1,2-1.2,4.4-0.5,6.5l20,55.7c0.3,0.8,0.4,1.6,0.4,2.4v8.3v27.5c0,1.7,1.3,3,3,3h40c1.7,0,3-1.3,3-3V110
                     v-5.4c0-2.1,0.9-4,2.5-5.3c0.1-0.1,0.1-0.1,0.2-0.2l24-24.5C122,72.2,122.6,68.5,121.1,65.5z M87,124.5H53V113h34V124.5z M53,134.5
                     v-4h34v4H53z M115.4,70.4L91.5,94.8c-2.9,2.5-4.5,6-4.5,9.8v2.4H53v-5.3c0-1.5-0.3-3-0.8-4.4l-20-55.7c-0.3-0.7,0-1.3,0.1-1.6
                     c0.2-0.3,0.5-0.8,1.3-1l0.7-0.2c0.9-0.2,1.9,0.2,2.3,1l13.2,26.4c0.7,1.3,2.2,2,3.6,1.5c1.4-0.5,2.3-1.9,2-3.3l-6.7-40.2
                     c-0.2-1.1,0.5-2.1,1.6-2.3l2.8-0.6c1.1-0.2,2.1,0.5,2.3,1.5L62.1,58c0.3,1.5,1.6,2.6,3.1,2.4c1.5-0.1,2.7-1.3,2.8-2.8l2.2-40.3
                     c0.1-1.1,0.9-1.9,2-1.9h3.1c1.1,0,1.9,0.8,2,1.9l2.2,40.3c0.1,1.5,1.3,2.7,2.8,2.8c1.5,0.1,2.9-0.9,3.2-2.4l6.5-32.6
                     c0.2-1.1,1.3-1.8,2.3-1.5l2.8,0.6c1.1,0.2,1.8,1.3,1.6,2.4l-9,45.1c-0.2,1.1,0.2,2.3,1.2,3c0.9,0.7,2.2,0.8,3.2,0.2l17.9-10
                     c0.5-0.3,1-0.3,1.6-0.2s1,0.5,1.2,1l1.1,2.1C116.1,68.9,116,69.8,115.4,70.4z"/>
                   </svg>`;
             }
              
              //console.log('minute',minute,type_icon,type);
              html += `<div class="liveTickerItem entry ${type_class}" data-type="${type}" data-order="${sortOrder}">
              <div class="entry-inner">
                <div class="icon_time_wrap">
                  <span class="event-time">
                  ${minute ? `${minute}’`  : `${type_icon ? `${type_icon}`  : "" }` }
                  </span>
                 ${(minute && type_icon) && type != 'Default'? `<span class="event-icon">${type_icon}</span>`  : `` }
                </div>
                <div class="entry-message">
                  <div class="entry-heading">
                    ${title ? `<h3>${title}</h3>`  : "" }
                  </div>
                  ${content ? `<p>${content}</p>`  : "" }
                  ${type == 'Tickets'? `${buttonLabel && buttonUrl? `<a class="button button--link" href="${!/^https?:\/\//.test(buttonUrl)?`//${buttonUrl}`:buttonUrl}">${buttonLabel}</a>`  : "" }`  : "" }
                </div>
               </div>
              </div>`;
        }
        
      }
      if ($('.live-pre-game-slider').hasClass('slick-initialized')) {
          $('.live-pre-game-slider').slick('unslick'); // Destroy the slider if initialized
      }
      $('.live-pre-game-slider-wrap .aico-skeleton-horizontal').remove();
      $('.live-pre-game-slider').html(html);
     
      initFeedSlider();    

      const playButtons = document.querySelectorAll('.live-pre-game-slider .has_mp4_video .icon-play');

      playButtons.forEach(button => {
        button.addEventListener('click', function() {

          const parentItem = button.closest('.has_mp4_video');

          // Pause all videos first
          const allVideos = document.querySelectorAll('.live-pre-game-slider .has_mp4_video video');

          allVideos.forEach(video => {
            video.pause();
            video.currentTime = 1; // Optional: reset the video to the beginning
            $(playButtons).show();
            $('.has_mp4_video').removeClass('video_playing');
          });


          if (parentItem) {
            // Find the video inside this parent
            const video = parentItem.querySelector('video');
            if (video) {
              video.play();
              $(button).hide(); // Hide the play button
              if ($(window).width() >= 540) {
                $(".insta-heading", parentItem).addClass("hidden");
              }
              setTimeout(function(){
                $(parentItem).addClass('video_playing');
              },200);
              // Show play button when video ends
              video.addEventListener('ended', function() {
                video.currentTime = 1;
                $(button).show(); // Show the play button again after the video ends
                $(parentItem).removeClass('video_playing');
                $(".insta-heading", parentItem).removeClass("hidden");
              });
              video.addEventListener("pause", function() {                
                $(".insta-heading", parentItem).removeClass("hidden");
              });
            } else {
              console.error('Video not found within the parent element');
            }
          }
        });
      });
      
    }
  });  
  
}

  
$(document).ready(function(){
  
  initFeedSlider();
  

  $(document).on('click','.live-pre-game-slider .has_mp4_video.video_playing', function() {
    
    const video = $(this).find('video').get(0); // Get the native DOM video element
    const playButton = $(this).find('.icon-play');
    const cardContent = $(this).find('.insta-heading');
    if (!video) {
      console.error('Video element not found');
      return;
    }
   
    if (video.paused) {
      video.play();
      playButton.hide(); // Hide the play button when video is playing      
    } else {
      video.pause();
      $('.live-pre-game-slider .has_mp4_video.video_playing').removeClass('video_playing');
      playButton.show(); // Show the play button when video is paused
      cardContent.removeClass("hidden");     
    }
  });
})
